import React from 'react';
import OnboardingWelcome from './OnboardingWelcome';
import GettingStartedCard from './GettingStartedCard';

/**
 * OnboardingBlock — composes the welcome overlay + the "Get set up" checklist.
 * WhatsNewCircles has moved behind the header icon (✨) in DashboardPage.
 * Each child self-gates via localStorage, so this can be dropped safely.
 */
export default function OnboardingBlock({
  userName,
  hasReceipts,
  hasCircle,
  hasCard,
  onScan,
  onCreateCircle,
  onAddCard,
  onOpenInsights,
}) {
  return (
    <div className="flex flex-col" style={{ gap: 12 }}>
      <OnboardingWelcome userName={userName} onScan={onScan} onExploreCircles={onCreateCircle} />
      <GettingStartedCard
        hasReceipts={hasReceipts}
        hasCircle={hasCircle}
        hasCard={hasCard}
        startCollapsed={hasReceipts}
        onScan={onScan}
        onCreateCircle={onCreateCircle}
        onAddCard={onAddCard}
        onOpenInsights={onOpenInsights}
      />
    </div>
  );
}